import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { Button } from '../../design-system';
import Image from 'next/image';
import { customImageLoader } from '@restworld/utils-common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JobPositionExplorer = function JobPositionExplorer(_ref) {
  var header = _ref.header,
      subheader = _ref.subheader,
      hasButton = _ref.hasButton,
      buttonText = _ref.buttonText,
      buttonIcon = _ref.buttonIcon,
      onSubmit = _ref.onSubmit,
      previewImage = _ref.previewImage,
      _ref$buttonFull = _ref.buttonFull,
      buttonFull = _ref$buttonFull === void 0 ? false : _ref$buttonFull;
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsxs(Body, {
      children: [/*#__PURE__*/_jsxs(Left, {
        children: [/*#__PURE__*/_jsx(_StyledH, {
          children: header
        }), /*#__PURE__*/_jsx(_StyledH2, {
          children: subheader
        }), hasButton && buttonText && onSubmit && /*#__PURE__*/_jsx(_StyledDiv, {
          children: /*#__PURE__*/_jsx(Button, {
            icon: buttonIcon,
            onClick: function onClick() {
              return onSubmit();
            },
            fullwidth: buttonFull,
            children: buttonText
          })
        })]
      }), /*#__PURE__*/_jsx(Right, {
        children: /*#__PURE__*/_jsx(BackgroundImage, _objectSpread(_objectSpread({}, previewImage), {}, {
          loader: customImageLoader,
          alt: "Restaurant",
          width: 449,
          height: 471
        }))
      })]
    })
  });
};

var Container = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-explorer__Container",
  componentId: "sc-6csyu4-0"
})(function () {
  return [{
    "display": "flex",
    "width": "100%",
    "flexDirection": "row",
    "justifyContent": "center"
  }];
});

var Body = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-explorer__Body",
  componentId: "sc-6csyu4-1"
})(function () {
  return [{
    "display": "flex",
    "height": "fit-content",
    "width": "100%",
    "flexDirection": "column-reverse",
    "overflow": "hidden",
    "borderRadius": "1.875rem",
    "@media (min-width: 1024px)": {
      "height": "29.438rem",
      "maxHeight": "29.438rem",
      "width": "57.688rem",
      "maxWidth": "57.688rem",
      "flexDirection": "row"
    }
  }];
});

var Left = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-explorer__Left",
  componentId: "sc-6csyu4-2"
})(function () {
  return [{
    "display": "flex",
    "width": "100%",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "justifyContent": "flex-start",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(73 41 131 / var(--tw-bg-opacity))",
    "paddingLeft": "2rem",
    "paddingRight": "2rem",
    "paddingTop": "2rem",
    "paddingBottom": "3rem",
    "@media (min-width: 1024px)": {
      "width": "29.625rem",
      "paddingTop": "5.125rem",
      "paddingBottom": "5.125rem",
      "paddingRight": "2rem",
      "paddingLeft": "3.938rem"
    }
  }];
});

var Right = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-explorer__Right",
  componentId: "sc-6csyu4-3"
})(function () {
  return [{
    "display": "flex",
    "height": "300px",
    "minHeight": "300px",
    "flex": "1 1 0%",
    "@media (min-width: 1024px)": {
      "height": "100%",
      "minHeight": "100%"
    }
  }];
});

var BackgroundImage = /*#__PURE__*/_styled(Image).withConfig({
  displayName: "job-position-explorer__BackgroundImage",
  componentId: "sc-6csyu4-4"
})(function () {
  return [{
    "width": "100%",
    "objectFit": "cover",
    "@media (min-width: 768px)": {
      "width": "100% !important"
    },
    "@media (min-width: 1024px)": {
      "width": "fit-content"
    }
  }];
});

var _StyledH = /*#__PURE__*/_styled("h2").withConfig({
  displayName: "job-position-explorer___StyledH",
  componentId: "sc-6csyu4-5"
})({
  "fontSize": "2.25rem",
  "lineHeight": "3.188rem",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "fontSize": "3rem",
    "lineHeight": "1"
  }
});

var _StyledH2 = /*#__PURE__*/_styled("h6").withConfig({
  displayName: "job-position-explorer___StyledH2",
  componentId: "sc-6csyu4-6"
})({
  "marginTop": "1rem",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "fontSize": "1.125rem",
    "lineHeight": "1.688rem"
  }
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-position-explorer___StyledDiv",
  componentId: "sc-6csyu4-7"
})({
  "marginTop": "2rem",
  "width": "100%"
});